import React from "react"
import { Card, CardContent, Typography, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Skeleton } from "@material-ui/lab"

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		minHeight: 124,
	},
	fileCount: {
		fontSize: "2.5rem",
		color: theme.palette.primary.dark,
		marginBottom: 7,
		fontWeight: 700,
		textAlign: "center",
	},
	cardBody: {
		padding: 0,
		"&:last-child": {
			paddingBottom: 0,
		},
	},
}))

const TotalFiles = ({ totalFiles = 0, isLoading = false }) => {
	const classes = useStyles()
	const [t] = useTranslation("global")

	return (
		<Card className={classes.root}>
			<CardContent className={classes.cardBody}>
				<Typography variant="h4" component="h3" className={classes.fileCount}>
					{isLoading ? <Skeleton width={150} height={40} /> : totalFiles.toLocaleString()}
				</Typography>
				{isLoading ? <Skeleton width={150} /> : <Typography variant="subtitle1">{t("dashboard.fileTypeText")}</Typography>}
			</CardContent>
		</Card>
	)
}

export default TotalFiles
